export default __webpack_public_path__ + "static/media/monitoringTrainingPlan.3ce7cd08.svg";